export default __webpack_public_path__ + "static/media/arrowdown.4516a238.svg";